import api from '@/lib/api';

export interface LexofficeConfig {
  connected: boolean;
  api_key: string; // '[HIDDEN]' if set
  last_test_status?: string | null;
  last_test_error?: string | null;
}

export interface FoundInvoice {
  found: boolean;
  id?: string;
  voucherNumber?: string;
  amount?: number;
  currency?: string;
  date?: string;
  error?: string;
}

class LexofficeService {
  async getConfig(): Promise<LexofficeConfig> {
    const { data } = await api.get('/lexoffice/config');
    return data?.data;
  }
  async saveConfig(api_key: string): Promise<LexofficeConfig> {
    const { data } = await api.put('/lexoffice/config', { api_key });
    return data?.data;
  }
  async test(): Promise<{ success: boolean; message?: string }> {
    const { data } = await api.post('/lexoffice/test', {});
    return { success: !!data?.success, message: data?.message };
  }
  async findInvoice(p: { email?: string; orderNumber?: string; amount?: string }): Promise<FoundInvoice> {
    const { data } = await api.get('/lexoffice/invoice', { params: p });
    return data?.data;
  }
  // win: tıklama anında senkron açılmış pencere (popup blocker'ı aşmak için)
  // PDF base64 olarak gelir (binary transfer bozulmasını önler) → blob'a çevrilir
  async openInvoicePdf(id: string, win?: Window | null): Promise<void> {
    const { data } = await api.get(`/lexoffice/invoice/${encodeURIComponent(id)}/pdf`);
    const b64 = data?.data?.base64;
    if (!b64) throw new Error('Kein PDF');
    const bytes = Uint8Array.from(atob(b64), (ch) => ch.charCodeAt(0));
    const blob = new Blob([bytes], { type: data?.data?.contentType || 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (win && !win.closed) win.location.href = url;
    else window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  }
}

export default new LexofficeService();
